<template>
  <v-container class="pa-0 mb-3">
    <v-hover v-slot="{ hover }">
      <v-card
        color="primaryAction"
        hover
        class="rounded-xl pa-3 editor-preview-container"
      >
        {{ $t("storyHub.chapterList.editorContents") }}
        <div class="rounded-xl preview-window">
          <div
            class="rounded-xl preview"
            unselectable="on"
            onselectstart="return false;"
            v-html="chapter.text"
          ></div>
        </div>
        <v-fade-transition>
          <v-overlay absolute :value="hover">
            <v-btn color="primaryAction" @click="toggleDialog(true)">
              {{ $t("storyHub.chapterList.editContents") }}
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </v-hover>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
      <EditChapter v-model="dialog" :chapter="chapter" :key="chapter.id" />
    </v-dialog>
  </v-container>
</template>
<script>
import EditChapter from "@/components/CreatorTools/StoryHub/ChapterEditor/EditChapter";
const DIALOG_HASH = "#edit";
export default {
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    EditChapter,
  },
  props: {
    chapter: Object,
  },
  mounted() {
    if (this.$route.hash == DIALOG_HASH) {
      this.dialog = true;
    }
  },
  watch: {
    "$route.hash"(newHash, oldHash) {
      if (newHash === DIALOG_HASH) {
        this.dialog = true;
      } else if (oldHash === DIALOG_HASH) {
        this.dialog = false;
      }
    },
  },
  methods: {
    toggleDialog(open) {
      if (open) {
        if (this.$route.hash == DIALOG_HASH) {
          this.dialog = true;
        } else {
          this.$router.push(DIALOG_HASH);
        }
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
<style scoped lang="scss">
$scale: 0.35;
$height: 450px;
.preview {
  transform: scale($scale);
  color: black;
  width: calc(100% / #{$scale});
  padding: 20%;
  height: $height;
  transform-origin: 0px 0px;
  text-align: left;
  overflow: hidden;
  margin: 0px 0px calc(-#{$height} * (1 - #{$scale}));
  ::v-deep video,
  ::v-deep audio
  {
    margin: 0px auto;
    max-width: 50%;
    display: block;
  }
}
.editor-preview-container {
  background-color: var(--v-primaryAction-base);
  overflow: hidden;
  position: relative;
  text-align: left;
  color: white;
}

.preview-window {
  background-color: white;
  overflow: hidden;
  border: 2px solid var(--v-accentElement-base);
}
</style>